import { makeStyles } from "@mui/styles";
import { BaseThemeOptions } from "themes/base";

export const useStyles = makeStyles((theme: BaseThemeOptions) => ({
	uploaderContainer: {
		display: "flex",
		width: "100%",
		height: "calc(100% - 70px)",
		overflow: "hidden",
	},
	uploaderContent: {
		display: "flex",
		flexDirection: "column",
		width: "100%",
		height: "100%",
	},
	errorsTableContainer: {
		height: "100%",
		"& div": {
			boxShadow: "none !important",
		},
	},
	configUploaderModal: {
		display: "flex",
		height: "100%",
	},
	configUploaderMenuHeader: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		padding: "16px",
		width: "100%",
	},
	buttonFont: {
		fontWeight: "700",
		color: "white.main",
	},
	configUploaderSubModal: {
		width: "54vw",
	},
	selectorUploader: {
		display: "flex",
		justifyContent: "center",
		height: "100%",
		flexDirection: "column",
	},
	selectorUploader2: {
		display: "flex",
		justifyContent: "center",
		height: "100%",
	},
	reUploadButton: {
		padding: "10px",
	},
}));
